






















import { computed } from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { redirectTo } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '确认订单',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        orderNo: string
      }>()

      // 点击查看订单
      handleOrderClick = () => {
        redirectTo('InstantDeliveryOrderIndex')
      }
    },
)
